import { Spinner } from '@platform/components';
import { GreenCircleCheckmark } from '../../svg/GreenCircleCheckmark';

export const SubmittingContent = () => {
  return (
    <div className='flex justify-center'>
      <Spinner />
    </div>
  );
};

export const SuccessConfirmationContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex flex-col gap-8 items-center mt-10 h-full'>
      <GreenCircleCheckmark size={150} />
      <div className='text-lg min-w-[288px] md:w-[500px] text-center flex flex-col gap-8'>
        {children}
      </div>
    </div>
  );
};

export const ErrorConfirmationContent = () => {
  return (
    <div className='md:absolute md:left-0 md:right-0 text-center mt-12 text-error-500'>
      <p>Something went wrong while submitting your update. Please try again later.</p>
      <p>If the problem persists, please contact support.</p>
    </div>
  );
};
